import { apiClient } from "../../../base/ApiClient";

export const getBankHolidays = async () => {
  const response = await apiClient.get('/core/bank-holiday/');
  return response.data;
};

export const createBankHoliday = async (data) => {
  const response = await apiClient.post('/core/bank-holiday/', data);
  return response.data;
};

export const deleteBankHoliday = async (id) => {
  const response = await apiClient.delete(`/core/bank-holiday/${id}/`);
  return response.data;
};